<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { SearchIcon } from '@/components/icons'

const props = defineProps<{ search: string }>()
const emit = defineEmits(['update:search'])

const searchValue = ref(props.search)

watch(
  () => props.search,
  (val) => {
    searchValue.value = val
  }
)

const updateSearch = () => {
  emit('update:search', searchValue.value)
}
const clearSearch = () => {
  searchValue.value = ''
  emit('update:search', '')
}
const showClearButton = computed(() => searchValue.value.length > 0)
</script>

<template>
  <div class="search-bar">
    <SearchIcon />
    <input
      type="text"
      placeholder="Search..."
      v-model="searchValue"
      @input="updateSearch"
    />
    <button 
      v-if="showClearButton" 
      class="clear-button" 
      @click="clearSearch"
      aria-label="Clear search"
    >
      <span class="cross">×</span>
    </button>
  </div>
</template>

<style scoped>
.search-bar {
  position: relative;
  opacity: 0.65;
  display: flex;
  align-items: center;
  gap: 0.3125rem;
  padding: 0.75rem;
  width: 100%;
  border-radius: 3.125rem;
  background-color: var(--color-background-bright);
  height: 3.125rem;
}
.search-bar > input {
  width: 100%;
  font-size: var(--font-size-small);
  font-style: italic;
  color: var(--color-text);
}
.search-bar > input::placeholder {
  color: var(--color-text);
  opacity: 0.75;
}
.clear-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-text);
  opacity: 0.7;
  padding: 0;
  margin-right: 0.125rem;
}
.clear-button:hover {
  opacity: 1;
}
.cross {
  font-size: var(--font-size-body);
  font-weight: 300;
  line-height: 1;
}
</style>
